import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, EventManager } from 'ng-jhipster';

import {  } from './lesson.model';
import { Lesson, LessonPopupService} from '.';
import { Student, StudentService } from '../student';
import { School, SchoolService } from '../school';

import { Reservation, ReservationStatus } from '../reservation/';
import { BackOfficeService } from '../../shared';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-lesson-choose-payment-method-dialog',
    templateUrl: './lesson-choose-payment-method-dialog.component.html'
})
export class LessonChoosePaymentMethodDialogComponent implements OnInit {

    lesson: Lesson;
    student: Student;
    school: School;
    constructor(
        public activeModal: NgbActiveModal,
        private eventManager: EventManager,
        private backofficeService: BackOfficeService,
        private alertService: AlertService,
        private studentService: StudentService,
        private schoolService: SchoolService
    ) {
    }

    ngOnInit(): void {
        this.studentService
            .getCurrent()
            .subscribe((s: Student) => {
                    this.student = s;
                },
                (res: HttpErrorResponse) => this.onError(res)
                );
        this.loadSchool();
    }

    loadSchool() {
        this.schoolService.findCurrent()
                          .subscribe( (s: School) => this.school = s , (error: any) => this.onError(error));
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    // This functionality is to allow to create a reservation and a checkout session to pay online
    createReservation() {
        let reservation: Reservation = new Reservation();
        reservation.lesson = this.lesson;
        reservation.status = ReservationStatus.WAITING_FOR_PAYMENT;
        reservation.student = this.student;
        reservation.school = this.school;
        this.backofficeService
            .createReservationWithCheckOutSession(reservation)
            .subscribe((chechoutUrl: string) => {
            // we open the checkout session in same browser so the user can pay
            window.location.href = chechoutUrl;
        });
    }

    private onError(error, lessonId?: any) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'jhi-lesson-choose-payment-method-popup',
    template: ''
})
export class LessonChoosePaymentMethodPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private lessonPopupService: LessonPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.lessonPopupService
                .open(LessonChoosePaymentMethodDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson-choose-payment-method-dialog.component.ts